import { doodBlockConfig, propertyValue } from "./dood-block-config";
import { cartPagePresetBlockBackgroundColorProperty } from "./cart-page-preset-block-background.util";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

/** Serializable preview VM for `ComoCreditBalanceCardBlockComponent`. */
export type ComoCreditBalanceCardBlockScenarioContent = {
  comoUser: {
    points_balance: {
      used_by_payment: boolean;
      monetary: number;
      non_monetary: number;
    };
    credit_balance: {
      used_by_payment: boolean;
      monetary: number;
      non_monetary: number;
    };
    assets: readonly [];
  } | null;
};

export const COMOCREDITBALANCECARDBLOCK_LEGACY_FIELD_ORDER = [];

const {
  comoCreditBalanceCardBlockDescriptor:
    _generatedComoCreditBalanceCardBlockDescriptor,
  comoCreditBalanceCardBlockBlocDefinition,
  comoCreditBalanceCardBlockDashboardLayout,
  comoCreditBalanceCardBlockConfig,
  comoCreditBalanceCardBlockResolveConfig,
  comoCreditBalanceCardBlockProperties,
  comoCreditBalanceCardBlockDefinitionSetupScenarios,
} = doodBlockConfig(
  {
    name: "Como - Credit balance card",
    componentType: "ComoCreditBalanceCardBlockComponent",
    category: "como",
    description: "Como - Credit balance card.",
    keywords: [],
    allowedIn: [{ bloc: "CartPageComponent", slot: "*" }],

    sharedFields: {},
  },

  () => ({
    background_color: cartPagePresetBlockBackgroundColorProperty(),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-page.fieldset.appearance.label",
            fields: ["background_color"],
          },
        ],
      },
    ],
  }),
);

export function comoCreditBalanceCardBlockDescriptor(): IBlockDescriptor;
export function comoCreditBalanceCardBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function comoCreditBalanceCardBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedComoCreditBalanceCardBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedComoCreditBalanceCardBlockDescriptor,
    comoCreditBalanceCardBlockProperties,
    fieldOrder,
  );
}

export {
  comoCreditBalanceCardBlockBlocDefinition,
  comoCreditBalanceCardBlockDashboardLayout,
  comoCreditBalanceCardBlockProperties,
  comoCreditBalanceCardBlockConfig,
  comoCreditBalanceCardBlockResolveConfig,
  comoCreditBalanceCardBlockDefinitionSetupScenarios,
};

export type ComoCreditBalanceCardBlockConfig =
  typeof comoCreditBalanceCardBlockConfig;
